import { ConfigProvider } from "antd";
import { useState } from "react";

// @ts-ignore
import { FormattedNumber } from "@umijs/max";

import styles from "./index.less";

import ScanToAddAssistantModal from "../components/ScanToAddAssistantModal";

import { BlackTheme } from "@packages/theme";

/**
 * 付费教育
 * @returns
 */
const Educations = () => {
  const [open, setOpen] = useState<boolean>(false);

  return (
    <ConfigProvider theme={BlackTheme}>
      <div className={styles.educations}>
        <div className={styles.title}>AI专业咨询与培训服务</div>
        <div className={styles.group}>
          <div className={styles.item}>
            <div>
              <div className={styles.title}>企业员工对AI技能培训</div>
              <div className={styles.desc}>
                提升企业员工对AI的认知和使用能力，促进智能化转型。包括但不限于接地气AI科普，如何在办公中用AI即刻提效，如何用AI产出你满意的效果，人机配合工作法等
              </div>
              <div className={styles["prices-left"]}>
                <div className={styles["price-item"]}>
                  <div className={styles.price}>
                    ¥
                    <FormattedNumber value={280} />
                  </div>
                  <div className={styles["price-unit"]}>/人/半天</div>
                </div>
                <div className={styles["price-item"]}>
                  <div className={styles.price}>
                    ¥
                    <FormattedNumber value={5000} />
                  </div>
                  <div className={styles["price-unit"]}>/不限/半天</div>
                </div>
                <div className={styles["price-item"]}>
                  <div className={styles.price}>
                    ¥
                    <FormattedNumber value={480} />
                  </div>
                  <div className={styles["price-unit"]}>/人/一天</div>
                </div>
                <div className={styles["price-item"]}>
                  <div className={styles.price}>
                    ¥
                    <FormattedNumber value={10000} />
                  </div>
                  <div className={styles["price-unit"]}>/不限/一天</div>
                </div>
              </div>
            </div>

            {/* <Button className={styles.contact} onClick={() => setOpen(true)}>
              联系我们
            </Button> */}
          </div>
          <div className={styles.item}>
            <div>
              <div className={styles.title}>企业一把手AI战略实践培训</div>
              <div className={styles.desc}>
                AI应用最新实践，智能化转型的战略理解，如何在公司落地智能化转型，智能化的组织管理
              </div>
              <div className={styles["prices-right"]}>
                <div className={styles["price-item"]}>
                  <div className={styles.price}>
                    ¥
                    <FormattedNumber value={999} />
                  </div>
                  <div className={styles["price-unit"]}>/人/半天精品课</div>
                </div>
                <div className={styles["price-item"]}>
                  <div className={styles.price}>
                    ¥
                    <FormattedNumber value={1999} />
                  </div>
                  <div className={styles["price-unit"]}>/人/一天拓展课</div>
                </div>
              </div>
            </div>

            {/* <Button className={styles.contact} onClick={() => setOpen(true)}>
              联系我们
            </Button> */}
          </div>
        </div>
      </div>

      <ScanToAddAssistantModal open={open} onClose={() => setOpen(false)} />
    </ConfigProvider>
  );
};

export default Educations;
